import styled from "styled-components";

export const Container = styled.div`
    display: block;
    width: 100%;
    overflow-x: auto;
`;

export const Table = styled.table`
    width: 100%;
    border-collapse: collapse;
    border-spacing: 0;
    border-radius: 10px;

    thead {
        tr {
            border-bottom: 1px solid #ccc;
            
            th {
                padding: 5px 10px;
                font-weight: bold;
                text-align: left;
                color: #64696c;
                height: 50px;
                vertical-align: bottom;
                background-color: #f6f6f6;
            }
        }
    }

    tbody {
        tr {
            border-top: 1px solid #ccc;
            
            &:hover {
                    outline: 2px solid #de5e45;
                }
            td {
                padding: 10px 10px;
                text-align: left;
                height: 50px;
                background-color: #f6f6f6;
                cursor: pointer;

                p {
                    color: ${props => props.theme.colors.danger};
                    font-weight: bold;
                    font-size: 9px;
                }
            }

            &:last-child {
                border-bottom: 5px solid #f6f6f6;
            } 

            &.error {
                td {
                    background: #ffabab;
                }
            }
        }
    }
`; 